import api from "../../config/http-common";
import CommonUtil from "../../Util/CommonUtils";



const get = (filter) => {
    return api.securedAxios().get("/web/nda/{companyId}".replace("{companyId}", localStorage.getItem("companyId")));
};



const deleteDocument = (ids) => {
  return api.securedAxios().delete("/web/nda/{ids}".replace("{ids}", ids));
};

const NDAService = {
  get,
  deleteDocument,
};


export default NDAService;
